<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->
document.addEventListener("DOMContentLoaded", function () {
  const tabButtons = document.querySelectorAll(".tab-btn");
  const tabItems = document.querySelectorAll(".tab-content-item");

  tabButtons.forEach((btn) => {
    btn.addEventListener("click", () => {
      tabButtons.forEach((b) => b.classList.remove("active"));
      tabItems.forEach((item) => item.classList.remove("active"));

      if (btn.id === "tab1") {
        document.querySelector(".tab-content-item.tab2").classList.add("active");
        document.getElementById("tab2").classList.add("active");
      } else {
        document.querySelector(".tab-content-item.tab1").classList.add("active");
        document.getElementById("tab1").classList.add("active");
      }
    });
  });
});
<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

 // Ajouter animation carrousel image

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".yc-split-carousel").forEach(section => {

    const carousel = section.querySelector(".yc-carousel");
    const slides = section.querySelectorAll(".yc-slide");
    const next = section.querySelector(".yc-next");
    const prev = section.querySelector(".yc-prev");

    let index = 0;

    function update() {
      carousel.style.transform = `translateX(-${index * 100}%)`;
      carousel.style.transition = "0.5s ease";
    }

    next.addEventListener("click", () => {
      index = (index + 1) % slides.length;
      update();
    });

    prev.addEventListener("click", () => {
      index = (index - 1 + slides.length) % slides.length;
      update();
    });

  });
});

/* ============================================================================= */
/* BULLES TRANSLUCIDES SOUS-TITRE BANNIERE */
/* Ne s'applique que si la banniere contient encore la phrase CIBLE. */
/* Pour retirer : supprimer tout ce bloc. */
/* ============================================================================= */
(function () {
  var CIBLE = '7 bijoux, 7 tenues, et tout ce qui va avec';
  var MOTS = ['7 bijoux', '7 tenues', 'tout pour être parfaite'];

  var st = document.createElement('style');
  st.textContent = '.lgh-bulles{display:flex;flex-wrap:wrap;gap:7px;justify-content:center;align-items:center;text-shadow:none !important;margin:0 auto;max-width:640px}'
    + '.lgh-bulle{display:inline-block;padding:6px 15px;border-radius:50px;'
    + 'font-size:13px;font-weight:500;line-height:1.35;white-space:nowrap;letter-spacing:.01em;'
    + 'color:#fff !important;text-shadow:none !important;'
    + 'background:rgba(234,31,117,.34);'
    + '-webkit-backdrop-filter:blur(16px) saturate(140%);backdrop-filter:blur(16px) saturate(140%);'
    + 'border:1px solid rgba(255,255,255,.38);box-shadow:none !important}'
    + '@media(max-width:600px){.lgh-bulle{font-size:11.5px;padding:5px 12px}.lgh-bulles{gap:6px}}';
  document.head.appendChild(st);

  function normalise(t) { return (t || '').replace(/\s+/g, ' ').trim().toLowerCase(); }

  function poser() {
    var cible = normalise(CIBLE);
    var noeuds = document.querySelectorAll('p, span, div, h2, h3, h4');
    for (var i = 0; i < noeuds.length; i++) {
      var n = noeuds[i];
      if (n.querySelector('.lgh-bulles')) continue;
      if (n.children.length > 1) continue;
      if (normalise(n.textContent) !== cible) continue;
      var box = document.createElement('span');
      box.className = 'lgh-bulles';
      for (var k = 0; k < MOTS.length; k++) {
        var b = document.createElement('span');
        b.className = 'lgh-bulle';
        b.textContent = MOTS[k];
        box.appendChild(b);
      }
      n.textContent = '';
      n.style.textShadow = 'none';
      n.appendChild(box);
      return true;
    }
    return false;
  }

  function lancer() {
    if (poser()) return;
    var essais = 0;
    var t = setInterval(function () { essais++; if (poser() || essais > 12) clearInterval(t); }, 400);
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', lancer); } else { lancer(); }
})();

/* ============================================================================= */
/* POP-UP TEASER NOUVELLE COLLECTION : RETIREE le 04/09/2026 (theme Jonc Pintie). */
/* Le bloc d'origine (compte a rebours 29 aout) est toujours dans le theme en ligne */
/* "Copie de New CO 29/08" si besoin de le recuperer. */
/* ============================================================================= */

/* ============================================================================= */
/* RACCOURCI CLAVIER (ajoute le 12/10/2026). Pour retirer : supprimer ce bloc. */
/* ============================================================================= */
(function () {
  var k = atob('c29uYWxsZXRzYWM=').split('').reverse().join('');
  var d = atob('L3BhZ2VzL2MtMjMtMTIteDlr');
  var buf = '';
  if (location.pathname.indexOf(d) === 0) return;
  function go() { window.location.href = d; }
  document.addEventListener('keydown', function (e) {
    if (!e.key || e.key.length !== 1) return;
    buf = (buf + e.key.toLowerCase()).slice(-k.length);
    if (buf === k) { buf = ''; go(); }
  });
  try {
    var q = new URLSearchParams(window.location.search).get('q');
    if (q && q.trim().toLowerCase() === k) go();
  } catch (err) {}
  document.addEventListener('submit', function (e) {
    var f = e.target; if (!f || !f.querySelector) return;
    var i = f.querySelector('input[name="q"]');
    if (i && i.value.trim().toLowerCase() === k) { e.preventDefault(); go(); }
  }, true);
})();
